
export interface ClockworkContextType {
    requests : {
        id : string;
        method : string;
        url : string;
        status : number;
        time : string;
    }[];
}

export class ClockworkContext {
    static clockwork : ClockworkContextType = { requests: [] };

    static addRequest(debug : ClockworkContextType['requests'][0]) {
        this.clockwork.requests.push(debug);
    }
  
    static setClockwork(Clockwork : ClockworkContextType) {
        this.clockwork = Clockwork;
    }
  
    static getClockwork() {
        return this.clockwork;
    }
}
  
